import React from "react";
import { TimesheetLineApproval } from "../../../store/ReportedTimeStore";
import ApprovalStatusTooltipContent from "../../timeTracking/tooltips/ApprovalStatusTooltipContent";
import EntityName from "../../views/list/columns/EntityName";
import TimeTrackingAdministrativeCategoryEntityName from "../../timeTracking/TimeTrackingAdministrativeCategoryEntityName";

export type ApprovalProjectInfo = {
    id: string;
    name: string;
    imageId?: string;
    isAdministrativeCategory?: boolean;
};

type Props = {
    timesheetLine: TimesheetLineApproval;
    project: ApprovalProjectInfo;
};

const ReportedTimeApprovalTooltip = (props: Props) => {
    const { timesheetLine, project } = props;

    return (
        <div className="timeline-tooltip time-tracking-tooltip">
            <div className="header">{_renderHeader(project)}</div>
            <div className="content">
                <ApprovalStatusTooltipContent approvers={timesheetLine.approvers} decision={timesheetLine.decision} />
            </div>
        </div>
    );
};

const _renderHeader = (project: ApprovalProjectInfo) => {
    if (project.isAdministrativeCategory) {
        return <TimeTrackingAdministrativeCategoryEntityName categoryId={project.id} />;
    }

    return <EntityName name={project.name} imageId={project.imageId} imageClassName="proj-logo" isTimelineView />;
};

export default ReportedTimeApprovalTooltip;
